import { Item, ItemDetails } from './components/item-card/ItemCard';
import { dummyitems, dummydetails } from './dummydata';

// TO-DO: move this to an env varible
const ROOT_API_URL = process.env.REACT_APP_ROOT_API_URL;
export const TESTING = process.env.REACT_APP_TESTING_MODE === "TESTING";

// Set once the user logs in (see App.tsx syncing this from AuthContext) so every subsequent
// request below can identify which customer_account it came from.
let currentUid: number | null = null;

export const setCurrentUid = (uid: number | null): void => {
  currentUid = uid;
};

export const withUid = (url: string): string => {
  if (currentUid == null) return url;
  return `${url}${url.includes('?') ? '&' : '?'}uid=${currentUid}`;
};

export const searchItems = async (
  queryParams: string,
  testing = false,
): Promise<{
  items: Item[];
  numberOfPages: number;
  totalRecords: number;
}> => {

  // For testing locally
  if (testing || TESTING){
    return {
      items: dummyitems,
      numberOfPages: 3,
      totalRecords: 75,
    };
  }

  try {
    const rawResponse = await fetch(
      withUid(`${ROOT_API_URL}/api/search${queryParams}`),
      {
        method: 'GET',
        // mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
          //   'Access-Control-Allow-Origin': 'http://localhost:3000',
          //   'Access-Control-Allow-Credentials': 'true',
        },
      },
    );
    const data = await rawResponse.json();
    if (data?.resultItems?.length > 0) {
      return {
        items: data.resultItems,
        numberOfPages: data.totalPages,
        totalRecords: data.totalRecords,
      };
    } else throw Error('');
  } catch (error) {
    return {
      items: [],
      numberOfPages: 1,
      totalRecords: 1,
    };
  }
};

export const registerUser = async (payload: {
  firstName: string;
  lastName: string;
  emailId: string;
  passwd: string;
}): Promise<{ success: boolean; message?: string }> => {
  try {
    const rawResponse = await fetch(withUid(`${ROOT_API_URL}/api/register`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await rawResponse.json();
    return { success: !!data.success, message: data.message };
  } catch (error) {
    return { success: false, message: 'Network error. Please try again.' };
  }
};

export const loginUser = async (
  emailId: string,
  passwd: string,
): Promise<{ success: boolean; message?: string; firstName?: string; emailId?: string; uid?: number }> => {
  try {
    const rawResponse = await fetch(withUid(`${ROOT_API_URL}/plogin`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      credentials: 'include',
      body: new URLSearchParams({ emailId, passwd }).toString(),
    });
    return await rawResponse.json();
  } catch (error) {
    return { success: false, message: 'Network error. Please try again.' };
  }
};

export const logoutUser = async (): Promise<void> => {
  try {
    await fetch(withUid(`${ROOT_API_URL}/logout`), { method: 'POST', credentials: 'include' });
  } catch (error) {
    // frontend clears its own auth state regardless of whether this call succeeds
  }
};

export const fetchMe = async (): Promise<{ loggedIn: boolean; firstName?: string; emailId?: string; uid?: number }> => {
  try {
    const rawResponse = await fetch(withUid(`${ROOT_API_URL}/api/me`), {
      method: 'GET',
      credentials: 'include',
    });
    return await rawResponse.json();
  } catch (error) {
    return { loggedIn: false };
  }
};

export const searchItemDetails = async (
  itemSku: string,
  itemWebsiteCode: string,
  testing = false,
): Promise<ItemDetails | null> => {
  // console.log('GETTING ITEM DETAILS: ', itemSku);

  // For testing locally
  if (testing) return dummydetails;

  try {
    const rawResponse = await fetch(
      withUid(`${ROOT_API_URL}/api/details?wc=${itemWebsiteCode}&sku=${itemSku}`),
      {
        method: 'GET',
        // mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
          //   'Access-Control-Allow-Origin': 'http://localhost:3000',
          //   'Access-Control-Allow-Credentials': 'true',
        },
      },
    );
    const data = await rawResponse.json();
    if (data) return data;
    throw Error('');
  } catch (error) {
    return null;
  }
};
